import { IApiError } from "../models/IApiError";
import { IOrderDetail } from "../models/IOrderDetail";
import { IOrders } from "../models/IOrders";
import { IOrderStatusList } from "../models/IOrderStatusList";
import { IReportFilter } from "../models/IReportFilter";
import { IPromoCode } from "../models/IPromoCode";
import { DateToString } from "../utils/Util";
import { configWithUserToken } from "./config";

export const getOrders = (restaurantId: string) => {
  return configWithUserToken.get<IOrders | IApiError[]>(
    "Order/GetOrderList/" + restaurantId + "?isOrderEnabled=1"
  );
};

export const getDisabledOrders = (userId: string, restaurantId: string) => {
  console.log("getorderItem:", userId + " * " + restaurantId);

  return configWithUserToken.get<IOrders>(
    "Order/GetOrderList/" + userId + "/" + restaurantId + "?isOrderEnabled=" + 0
  );
};

export const getOrdersByDate = (
  userId: string,
  startDate?: Date|null,
  endDate?: Date|null
) => {
  console.log(
    "getorderItem:",
    userId + " ?startDate= " + startDate + "?endDate=" + endDate
  );

  if (startDate == undefined || endDate == undefined) {
    return configWithUserToken.get<IOrders>("Order/History/" + userId);
  } else {
    return configWithUserToken.get<IOrders>(
      "Order/GetOrderReport/" +
       
        " ?startDate= " +
        startDate +
        "?endDate=" +
        endDate + "?id=" +userId 
    );
  }
};
export const getOrdersByFilter = (
  filter: IReportFilter,
) => {
  const endDate=DateToString(filter.EndDate) 
  const startDate=DateToString(filter.StartDate) 

    return configWithUserToken.get<IOrders>(
      "Order/GetOrderReport/" +startDate+'/' +   endDate +'/' +  filter.RestaurantId
    );
  
};

export const getOrderDetailById = (OrderId: string) => {
  return configWithUserToken.get<IOrderDetail>(
    "Order/GetOrderDetailsById/" + OrderId
  );
};

export const getOrderStatusList = () => {
  return configWithUserToken.get<IOrderStatusList>(
    "OrderStatus/OrderStatusList"
  );
};

export const UpdateOrderStatus = (orderId: string, orderStatus: string, cancellationReason?: string) => {
  const params = cancellationReason ? `?cancellationReason=${encodeURIComponent(cancellationReason)}` : "";
  return configWithUserToken.put(
    `Order/UpdateOrderStatus/${orderId}/${orderStatus}${params}`
  );
};

export const getPromoCodeById = (promoCodeId: string) =>
  configWithUserToken.get<IPromoCode>(`PromoCode/${promoCodeId}`);
